export default "<div class=\"branding\">\n    InTransportation\n</div>\n"